import debugPkg from 'debug';

debugPkg.log = console.log.bind(console);

export const debug = (key) => (data: any, data2?: any) => {
  debugPkg(`vysta:${key}`)(data, data2);
};
